<script>

	import { mapState } from 'vuex';
	import {
		PRICE_MONTHLY_COMPANY,
	} from '@/constants';


	export default {
		name: 'buybox',
		props: [
			'company'
		],
		data() {
			return {
				PRICE_MONTHLY_COMPANY: (PRICE_MONTHLY_COMPANY / 100).toFixed(2),
			};
		},
		computed: {
			...mapState({
				'registered': state => state.user.registered,
				'isLoggedIn': state => state.user.isLoggedIn
			})
		},
		methods: {
			addCompany() {
				if (this.isLoggedIn || this.registered) {
					this.$store.dispatch('subToCompany')
				} else {
					this.$store.dispatch('showModal', 'SignUp')
				}
			}
		},
		watch: {
			registered (registered) {
				if (registered === true || this.isLoggedIn === true) {
					this.$store.dispatch('subToCompany')
				}
			}
		}
	}

</script>

<template>
	<div class='buybox'>
		<button
			class='light-green'
			@click='addCompany()'
			type='button'>
				<i class='ion-unlocked' />&nbsp;&nbsp;&nbsp;&nbsp;Purchase {{ company }} pass for $19.95 / month
		</button>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/BuyBox/BuyBox.vue